import { render, staticRenderFns } from "./NewsDetailsSeven.vue?vue&type=template&id=03b08cda"
import script from "./NewsDetailsSeven.vue?vue&type=script&lang=js"
export * from "./NewsDetailsSeven.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsSeven.vue?vue&type=style&index=0&id=03b08cda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports